"use strict";

var _objectWithoutProperties = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _components = require("./components");

var _core = require("@emotion/core");

var Label = _stylitas.styled.label(_templateObject(), _components.radioInputLabel, _components.radioInputLabelError);

var RadioInputDiv = _stylitas.styled.div(_templateObject2(), _components.radioInputItem);

var Span = _stylitas.styled.span(_templateObject3(), _components.radioInputButton);

var RadioInp = _stylitas.styled.input(_templateObject4(), _components.inputStyle, _components.inputStyleChecked);

var propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.node.isRequired,
  label: _propTypes.string.isRequired,
  id: _propTypes.string.isRequired,
  onChange: _propTypes.func,
  onBlur: _propTypes.func,
  value: _propTypes.any,
  name: _propTypes.string,
  checked: _propTypes.bool,
  fullWidth: _propTypes.bool,
  error: _propTypes.bool
} : {};
var defaultProps = {
  checked: false,
  error: false,
  fullWidth: false
};

var RadioInput = _react.default.forwardRef(function (props, ref) {
  var id = props.id,
      name = props.name,
      label = props.label,
      value = props.value,
      onChange = props.onChange,
      onBlur = props.onBlur,
      fullWidth = props.fullWidth,
      checked = props.checked,
      error = props.error,
      otherProps = _objectWithoutProperties(props, ["id", "name", "label", "value", "onChange", "onBlur", "fullWidth", "checked", "error"]);

  return (0, _core.jsx)(RadioInputDiv, null, (0, _core.jsx)(RadioInp, (0, _extends2.default)({
    type: "radio",
    name: name,
    id: id,
    value: value,
    ref: ref,
    checked: checked,
    onChange: onChange,
    onBlur: onBlur
  }, otherProps)), (0, _core.jsx)(Label, {
    error: error,
    htmlFor: id,
    fullWidth: fullWidth
  }, (0, _core.jsx)("div", null, (0, _core.jsx)(Span, {
    checked: checked
  }), label)));
});

exports.RadioInput = RadioInput;
process.env.NODE_ENV !== "production" ? RadioInput.propTypes = propTypes : void 0;
RadioInput.defaultProps = defaultProps;